import { Box, Fab, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { AiStars } from '../../../assets/icons'
import { useChatStore } from '../../../stores/chatStore'
import colors from '../../../theme/colors'

/**
 * Fab-Launcher (Muster: FloatingActionButtonsBar), toggelt isOpen im
 * chatStore. FloatingActionButtonsBar sitzt in derselben Ecke (bottom-right,
 * mobile bottom-left) mit zIndex 1000 — hier daher deutlich höherer
 * bottom-Offset (stapelt oberhalb statt zu überlappen) und ein zIndex über
 * dem persistenten Drawer (theme.zIndex.drawer), damit der Launcher auch bei
 * geöffnetem Chat als Schließen-Button klickbar bleibt.
 */
const AiChatLauncher: FC = () => {
  const { t } = useTranslation('ai')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const isOpen = useChatStore(state => state.isOpen)
  const openChat = useChatStore(state => state.open)
  const closeChat = useChatStore(state => state.close)

  const handleToggle = () => {
    if (isOpen) closeChat()
    else openChat()
  }

  if (isOpen) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '96px',
        right: isMobile ? null : 0,
        left: isMobile ? '16px' : null,
        zIndex: theme.zIndex.drawer + 1
      }}
    >
      {/* Desktop: docked to the right edge as a half bubble so the launcher
          doesn't cover content along the right edge (e.g. action columns).
          Expands to full width on hover/focus. */}
      <Fab
        color="default"
        onClick={handleToggle}
        aria-label={t('chat.launcherLabel')}
        sx={{
          color: 'white',
          padding: 1,
          backgroundColor: colors.floatingButtonBg,
          boxShadow: `0px 4px 6px ${colors.floatingButtonShadow}`,
          ...(!isMobile && {
            width: 36,
            minWidth: 36,
            borderRadius: '28px 0 0 28px',
            transition: theme.transitions.create(['width', 'background-color', 'box-shadow']),
            '&:hover, &:focus-visible': { width: 56 }
          })
        }}
      >
        {isOpen ? null : <AiStars />}
      </Fab>
    </Box>
  )
}

export default AiChatLauncher
